import { BaseEntity } from '../../models';
import { Empresa } from '../empresa';
import { EnumNivelVisualizacaoResultadoPedido } from './enums/nivel-visualizacao-resultado-pedido.enum';
import { Representante } from '../pessoa/representante';
import { UsuarioEmailAdministrativo } from './email/administrativo';
import { UsuarioExpedicao } from './expedicao';
import { UsuarioLinha } from './linha';
import { UsuarioMarca } from './marca';
import { UsuarioUnidadeNegocio } from './unidade-negocio';
import { isPerfilAdministrador, isPerfilAtendente, isPerfilGerente } from './usuario-perfil';
import { usuarioAtivo } from './usuario-situacao';

export class Usuario implements BaseEntity {
    readonly id: number;
    createdAt: Date;
    idUsuarioCreated: number;
    usuarioCreated: Usuario;
    updatedAt: Date;
    idUsuarioUpdated: number;
    usuarioUpdated: Usuario;
    idEmpresa: number;
    empresa: Empresa;
    nome: string;
    login: string;
    senha: string;
    situacao: number;
    perfil: number;
    idRepresentante: number;
    representante: Representante;
    avatarUrl: string;
    urlAssinaturaEmail: string;
    usuariosExpedicao: UsuarioExpedicao[];
    fone: string;
    celular: string;
    marcas: UsuarioMarca[];
    linhas: UsuarioLinha[];
    emailsAdministrativos: UsuarioEmailAdministrativo[];
    unidadesNegocios: UsuarioUnidadeNegocio[];

    // Permissões
    podeSalvarCnpjCpfInvalido: boolean;
    podeImportarErp: boolean;
    podeImportarEcommerce: boolean;

    // Permissões Clientes
    podeEditarCliente: boolean;
    podeCadastrarClienteExterior: boolean;
    podeEditarClienteSegmentos: boolean;

    // Permissões - Análises de Mercado
    podeGerenciarRevisoesAnalisesMercado: boolean;

    // Permissões Campanhas
    podeAnalisarCampanhas: boolean;

    // Permissões Metas
    podeEditarMetas: boolean;

    // Permissões PLM
    podeEditarDadosPLM: boolean;
    podeAcompanharGatesPLM: boolean;
    podeDecidirGatesPLM: boolean;
    podeEncerrarProdutoPLM: boolean;

    // Permissões Pedidos
    // Pedido - Ações
    podeConfirmarPedido: boolean;
    podeLiberarPedido: boolean;
    podeEditarPedidoNaoLiberado: boolean;
    podeEditarPedidoConfirmado: boolean;
    podeEditarPedidoComissao: boolean;
    podeEditarEntregas: boolean;
    podeExportarErp: boolean;
    podeRevisarPedidoOrcamento: boolean;
    podeSimularPedido: boolean;
    podeInformarValidadePropostaComercial: boolean;
    // Pedidos - Dados
    nivelVisualizacaoResultadoPedido: number;


    // Acessos Restritos
    acessoConfiguracoes: boolean;
    acessoUsuarios: boolean;
    acessoProspeccaoOutbound: boolean;
    acessoComissoes: boolean;
    acessoTabelasPrecos: boolean;

    // Logs de Situação
    dataInativacao: Date;
    idUsuarioInativacao: number;
    usuarioInativacao: Usuario;
    justificativaInativacao: string;

    acessoAI: boolean;

    constructor() {
        this.situacao = usuarioAtivo.id;
        this.usuariosExpedicao = [];
        this.marcas = [];
        this.linhas = [];
        this.emailsAdministrativos = [];
        this.unidadesNegocios = [];

        // Permissões
        this.setPermissoes();
    }

    /** Seta as flags das permissões */
    private setPermissoes() {
        this.podeSalvarCnpjCpfInvalido = false;
        this.podeImportarErp = false;
        this.podeImportarEcommerce = false;

        // Clientes
        this.podeEditarCliente = false;
        this.podeCadastrarClienteExterior = false;
        this.podeEditarClienteSegmentos = false;

        // Metas
        this.podeEditarMetas = false;

        // PLM
        this.podeEditarDadosPLM = false;
        this.podeAcompanharGatesPLM = false;
        this.podeDecidirGatesPLM = false;
        this.podeEncerrarProdutoPLM = false;

        // Pedidos - Ações
        this.podeConfirmarPedido = false;
        this.podeLiberarPedido = false;
        this.podeEditarPedidoNaoLiberado = false;
        this.podeEditarPedidoConfirmado = false;
        this.podeEditarPedidoComissao = false;
        this.podeEditarEntregas = false;
        this.podeExportarErp = false;
        this.podeRevisarPedidoOrcamento = false;
        this.podeSimularPedido = false;
        // Pedidos - Dados
        this.nivelVisualizacaoResultadoPedido = EnumNivelVisualizacaoResultadoPedido.SemAcesso;
    }

    /** Seta as flags dos acessos restritos */
    setAcessos(perfilUsuario: number) {
        this.acessoUsuarios = false;
        this.acessoProspeccaoOutbound = isPerfilAdministrador(perfilUsuario) || isPerfilAtendente(perfilUsuario) || isPerfilGerente(perfilUsuario);
        this.acessoComissoes = false;
        this.acessoTabelasPrecos = false;
        this.acessoAI = false;
    }
}
